var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_319_245)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5639 15.2008C44.4072 16.1866 43.8288 16.6795 43.211 17.0935C41.795 18.0426 40.2048 18.7013 38.5325 19.0314C37.8029 19.1755 37.0454 19.2359 35.5304 19.3568C31.7238 19.6606 29.8205 19.8125 28.2326 20.3733C24.5599 21.6706 21.6711 24.5594 20.3738 28.2321C19.813 29.82 19.6611 31.7233 19.3573 35.5299C19.2364 37.0449 19.176 37.8024 19.0319 38.532C18.7018 40.2043 18.0431 41.7946 17.094 43.2106C16.68 43.8283 16.1871 44.4067 15.2013 45.5634C12.7245 48.4698 11.486 49.9231 10.7598 51.4425C9.08008 54.9568 9.08008 59.0422 10.7598 62.5565C11.486 64.0759 12.7244 65.5291 15.2013 68.4356C16.187 69.5922 16.68 70.1708 17.094 70.7885C18.0431 72.2045 18.7018 73.7947 19.0319 75.467C19.176 76.1966 19.2364 76.9541 19.3573 78.4691C19.6611 82.2757 19.813 84.179 20.3738 85.7669C21.6711 89.4396 24.5599 92.3284 28.2326 93.6257C29.8205 94.1865 31.7238 94.3384 35.5304 94.6422C37.0454 94.7631 37.8029 94.8235 38.5325 94.9676C40.2048 95.2977 41.795 95.9564 43.211 96.9055C43.8288 97.3195 44.4071 97.8124 45.5639 98.7982C48.4704 101.275 49.9236 102.514 51.443 103.24C54.9573 104.919 59.0427 104.919 62.557 103.24C64.0764 102.514 65.5296 101.275 68.4361 98.7982C69.5929 97.8124 70.1712 97.3195 70.789 96.9055C72.205 95.9564 73.7952 95.2977 75.4675 94.9676C76.1971 94.8235 76.9546 94.7631 78.4696 94.6422C82.2762 94.3384 84.1795 94.1865 85.7674 93.6257C89.4401 92.3284 92.3289 89.4396 93.6262 85.7669C94.187 84.179 94.3389 82.2757 94.6427 78.4691C94.7636 76.9541 94.824 76.1966 94.9681 75.467C95.2982 73.7947 95.9569 72.2045 96.906 70.7885C97.32 70.1708 97.8129 69.5924 98.7987 68.4356C101.276 65.5291 102.514 64.0759 103.24 62.5565C104.92 59.0422 104.92 54.9568 103.24 51.4425C102.514 49.9231 101.276 48.4699 98.7987 45.5634C97.8129 44.4067 97.32 43.8283 96.906 43.2105C95.9569 41.7946 95.2982 40.2043 94.9681 38.532C94.824 37.8024 94.7636 37.0449 94.6427 35.5299C94.3389 31.7233 94.187 29.82 93.6262 28.2321C92.3289 24.5594 89.4401 21.6706 85.7674 20.3733C84.1795 19.8125 82.2762 19.6606 78.4696 19.3568C76.9546 19.2359 76.1971 19.1755 75.4675 19.0314C73.7952 18.7013 72.2049 18.0426 70.789 17.0935C70.1712 16.6795 69.5929 16.1866 68.4361 15.2008C65.5296 12.7239 64.0764 11.4855 62.557 10.7593C59.0427 9.07959 54.9573 9.07959 51.443 10.7593C49.9236 11.4855 48.4703 12.724 45.5639 15.2008ZM77.7741 46.8494C79.2838 45.3397 79.2838 42.892 77.7741 41.3823C76.2644 39.8726 73.8167 39.8726 72.3069 41.3823L49.2683 64.421L41.6929 56.8456C40.1832 55.3359 37.7355 55.3359 36.2258 56.8456C34.7161 58.3553 34.7161 60.803 36.2258 62.3127L46.5347 72.6216C48.0444 74.1313 50.4921 74.1313 52.0018 72.6216L77.7741 46.8494Z",
    fill: "url(#paint0_linear_319_245)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_319_245",
    x: 0,
    y: -3.00049,
    width: 114,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_319_245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_245",
    x1: 13.7948,
    y1: 23.229,
    x2: 114.704,
    y2: 38.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.d8fb6cfcff3ae0ed6cc63bb65c4f5aa4.svg";
export { ForwardRef as ReactComponent };